import { ItineraryOption } from "../models/itinerary-options.model";

export const FAST_OPTION:ItineraryOption = {
    id: 'fast',
    label: 'routeForm.fastest',
    options: {
        optimize: 'QUICK',
        walkReluctance: 10,
    }
}

export const FEWER_TRANSFERS_OPTION:ItineraryOption = {
    id: 'fewerTransfers',
    label: 'routeForm.withFewerTransfers',
    options: {
        walkBoardCost: 1500,
        transferPenalty: 600,
    }
}

export const LESS_WALK_OPTION:ItineraryOption = {
    id: 'lessWalk',
    label: 'routeForm.withLessWalk',
    options: {
        walkReluctance: 35,
        bikeReluctance: 15,
    }
}



export const ITINERARY_OPTIONS = [FAST_OPTION, FEWER_TRANSFERS_OPTION, LESS_WALK_OPTION];
